<template>
	<div>
		<div class="bread-line">
		<Breadcrumb>
			<Breadcrumb-item>库存管理</Breadcrumb-item>
			<Breadcrumb-item>商品库存查询</Breadcrumb-item>
		</Breadcrumb>
		<div class="wms-search-wapper wms-mt15">
			<Form ref="searchTaskForm" :label-width="80" inline :model="searchTaskForm"
				class="wms-form-check oneline">
				<Form-item label="货主：" prop="startOwnerNameList">
					<FormSelectSearch  @getDataSource="updateOwnerList" @on-change="getGoodsStateByOwner" ref="ownerSelect" searchType="owner" v-model="searchTaskForm.owner" :filterable="true"></FormSelectSearch>
				</Form-item>
				<Form-item label="商品编号：" prop="code">
					<FormAutoSearch v-model="searchTaskForm.code" searchType="goodsCode"></FormAutoSearch>
				</Form-item>
				<Form-item label="商品条码：" prop="startOwnerNameList">
					<FormAutoSearch v-model="searchTaskForm.barcode" searchType="barcode"></FormAutoSearch>
				</Form-item>
				<Form-item label="商品名称：" prop="name">
					<FormAutoSearch v-model="searchTaskForm.name" searchType="goodsName"></FormAutoSearch>
				</Form-item>
				<Form-item label="质量类型：" prop="goodsStatus" style="width: 250px">
					<Select v-model="searchTaskForm.goodsStatus" :clearable="true" size="small" placeholder="请选择质量类型">
						<Option v-for="status in goodsStatusList" :key="status.value" :value="status.value">{{status.label}}</Option>
					</Select>
				</Form-item>
				<Form-item :label-width="160" label="显示零库存数据：" prop="ifShowZeroData" style="width: 250px;">
					<Checkbox v-model="searchTaskForm.ifShowZeroData" @on-change="changeShowZeroData"></Checkbox>
				</Form-item>
				<Form-item :label-width="10" style="width: auto">
					<Button type="ghost" size="small" class="wms-mr10 wms-btn-ghost" @click="search">搜索</Button>
					<Button type="ghost" size="small" class="wms-mr10 wms-btn-ghost" @click="clearAll">清空</Button>
				</Form-item>
			</Form>
		</div>

		<IconBtnGroup :dataSource="btnGroup" @on-click="btnchange" class="wms-mt10" :columnDefs="columnDefs" @col-change="colChange"></IconBtnGroup>
		<div class="wms-form-filter wms-mt10">
			<span>sku件数：{{skuNum}}</span>
			<span class="wms-ml10">可用数量：{{useAbleNum}}</span>
			<span class="wms-ml10">总货值：{{totalPrice}}</span>
		</div>
		<AgGridVueCustom style="width: 100%;" class="ag-fresh wms-table wms-mt10"
            :class="{'wms-no-data': totalCount===0}"
            suppressNoRowsOverlay
            :suppressMovableColumns="false"
            :gridOptions="gridOptions"
            :columnDefs="columnDefs"
            :rowData="rowData"
            :enableColResize="true"
            rowSelection="multiple"
            :suppressRowClickSelection="true"
            :groupUseEntireRow="true"
            :rowHeight="tableRowHeight"
            :headerHeight="tableHeaderRowHeight"
            domLayout="autoHeight"
            :overlayLoadingTemplate="loadingTemplate"
            :enableServerSideSorting="true"
            :sortChanged="sortChanged"
            :rowClassRules="rowClassRules"
            :selectionChanged="selectionChanged"
		></AgGridVueCustom>
		<div class="wms-page-wapper">
			<span class="setsize ">第{{(currentPage - 1) * defaultPageSize + 1}}-{{ totalCount - currentPage * defaultPageSize < 0 ? totalCount : currentPage * defaultPageSize
                    }}条记录,   总共{{totalCount}}条记录</span>
			<Page :total="totalCount" :page-size="defaultPageSize" :page-size-opts="defaultPageSizeOpt" @on-page-size-change="pageSizeChange"
				@on-change="pageChange" :current="currentPage" show-elevator show-sizer show-total class="wms-page float-right wms-mr5"></Page>
		</div>
	</div>
	</div>
</template>
<script type="text/ecmascript-6">
import {InterObj} from 'utils/serviceConst'
import {loadingTemplate} from 'utils/template'
import {TableHeaderRowHeight, TableRowHeight, DefaultPageSize, DefaultPageSizeOpt} from 'utils/const'
import CellOperate from 'common/agTableComponent/cellOperate.vue'
import IconBtnGroup from 'common/iconBtnGroup/iconBtnGroup.vue'
import FormAutoSearch from 'common/formSearch/formAutoSearch.vue'
import FormSelectSearch from 'common/formSearch/formSelectSearch.vue'
import store from 'storejs'
import {_doForm} from 'utils/utils.js'
export default {
    name: 'stock-manage-goods-search',
    components: {
        CellOperate,
        IconBtnGroup,
        FormAutoSearch,
        FormSelectSearch
    },
    data: function() {
        return {
            value1: '',
            data1: [],
            useAbleNum: '', // 可用数量
            skuNum: '', // sku件数
            totalPrice: '', // 总货值
            goodsNameList: [], // 商品名字列表
            goodsNameListSearchloading: false,
            goodsCodeList: [], // 商品名字列表
            goodsCodeListSearchloading: false,
            searchTaskForm: {
                owner: '',
                code: '',
                name: '',
                barcode: '',
                goodsStatus: '',
                ifShowZeroData: false
            },
            ownerList: [],
            goodsStatusList: [],
            orderByClause: '',
            searchParams: {},
            btnGroup: [
                {
                    text: '导出',
                    icon: 'icon-export',
                    click: this.export
                }
            ],
            rowClassRules: {
                'wms-row-warning': function(params) {
                    return params.data.stockWarningLevel === '1'
                }
            },
            gridOptions: {}, // 表格配置
            columnDefs: [
                {
                    headerName: '',
                    field: 'selection',
                    checkboxSelection: true,
                    headerCheckboxSelection: true,
                    width: 60,
                    maxWidth: 60,
                    minWidth: 60,
                    pinned: 'left',
                    suppressSorting: true
                },{
                    headerName: '序号',
                    field: 'rank',
                    pinned: 'left',
                    minWidth: 60,
                    width: 60,
                    cellRenderer: function(params) {
                        let index = Number(params.rowIndex) + 1
                        return '<span>' + index + '</span>'
                    }
                },
                {headerName: '货主名称', field: 'owner', minWidth: 300},
                {headerName: '商品编号', field: 'code', minWidth: 150},
                {headerName: '商品条码', field: 'barcode', minWidth: 150},
                {headerName: '商品名称', field: 'name', minWidth: 150},
                {headerName: '规格', field: 'model', minWidth: 150},
                {headerName: '单位', field: 'unit', minWidth: 50},
                {headerName: '总数量', field: 'totalCount', minWidth: 100},
                {
                    headerName: '重量',
                    field: 'goodsWeight',
                    minWidth: 100,
                    cellRenderer: function(params) {
                        var weight = params.data.goodsWeight + 'kg'
                        return weight
                    }
                },
                {headerName: '质量类型', field: 'goodsStatus', minWidth: 100},
                {headerName: '可用数量', field: 'usableCount', minWidth: 100},
                //{headerName: '在途数量', field: 'wayCount', minWidth: 100},
                {headerName: '保质天数', field: 'shelfLife', minWidth: 100}
            ], // 表格列
            rowData: [], // 表格数据
            tableHeaderRowHeight: TableHeaderRowHeight, // 表格头高
            tableRowHeight: TableRowHeight, // 表格行高
            defaultPageSize: DefaultPageSize, // 默认一页条数
            defaultPageSizeOpt: DefaultPageSizeOpt, // 下拉
            currentPage: 1, // 当前页
            totalCount: 0, // 总数量
            loadingTemplate,
            selectCodes: [],
        }
    },

    methods: {
        // 清空
        clearAll() {
            const ifShowZeroData= this.searchTaskForm.ifShowZeroData
            this.searchTaskForm = {
                owner: '',
                code: '',
                name: '',
                barcode: '',
                goodsStatus: '',
                ifShowZeroData: ifShowZeroData
            }
        },
        updateOwnerList(list) {
            this.ownerList  = list
        },
        async getGoodsStateByOwner(v) {
            //  查询质量类型
            let self = this
            let ownerCode
            let owner = this.searchTaskForm.owner
            let ownerObj = _.find(this.ownerList, o => o.name === owner)
            ownerCode = ownerObj && ownerObj.code
            let res = await requestMethods.get(InterObj.getGoodsState, {ownerCode})
            if (res.result === 'success') {
                this.goodsStatusList = res.data
                this.goodsStatusList.forEach(item => {
                    item.label = item.name
                    item.value = item.code
                })
            } else {
                self.$Loading.error()
                self.$Notice.warning({desc: res.msg})
            }
        },
        changeShowZeroData(v) {
            const key = this.$router.currentRoute.path + '-SHOWZERO'
            store.set(key, v)
		},
        // 查询
        async search() {
            this.searchParams = {
                ...this.searchTaskForm,
                //	添加是否先零库存的参数， 显示传-1， 不显示传0
                moreThanTotalCount: this.searchTaskForm.ifShowZeroData ? -1 : 0
            }
            this.currentPage = 1
            await [this.searchStock(), this.searchGoodsStatistic()]
        },
        // 查询库存信息列表
        async searchStock() {
            this.gridOptions.api.showLoadingOverlay()
            let data = await requestMethods.get(InterObj.selectStorageGoodsListGroupByGoodsCode, {
                ...this.searchParams,
                orderByClause: this.orderByClause,
                page: this.currentPage,
                pageSize: this.defaultPageSize
            })
            this.gridOptions.api.hideOverlay()
            this.gridOptions.api.deselectAll()
            if (data.result === 'success') {
                this.rowData = data.data.goodsList
                this.totalCount = Number(data.data.totalCount)
            } else {
                this.$Notice.warning({desc: data.msg})
            }
        },
        // 查询库存统计的信息
        async searchGoodsStatistic() {
            let data = await requestMethods.get(InterObj.selectStorageGoodsStatisticByGoodsCode, {
                ...this.searchParams
            })
            if (data.result === 'success') {
                this.skuNum = data.data.skuCount
                this.useAbleNum = data.data.usableCount
                this.totalPrice = data.data.totalPrice
            } else {
                this.$Notice.warning({desc: data.msg})
            }
        },
        // 分页
        pageChange(value) {
            this.currentPage = value
            this.searchStock()
        },
        // 分页大小变化
        pageSizeChange(value) {
            this.defaultPageSize = value
            if (this.currentPage === 1) {
                this.searchStock()
            }
        },
        // 排序
        sortChanged() {
            let sortModal = this.gridOptions.api.getSortModel()
            this.orderByClause = (sortModal[0] ? sortModal[0].colId + ':' + sortModal[0].sort : '')
            this.searchStock()
        },
        // 选中状态的数据
        selectionChanged() {
            let selectArr = this.gridOptions.api.getSelectedRows()
            this.selectCodes = _.map(selectArr, 'groupIds')
        },
        // 导出
        export() {
            //	添加是否先零库存的参数， 显示传-1， 不显示传0
			const moreThanTotalCount= this.searchTaskForm.ifShowZeroData ? -1 : 0
            let columnStrArray = []
            let owner = this.searchTaskForm.owner
            let ownerObj = _.find(this.ownerList, o => o.name === owner)
            let ownerCode = ownerObj && ownerObj.code

            this.columnDefs.forEach(function(element) {
                if (['selection', 'rank'].indexOf(element.field) < 0 && element.show) {
                    columnStrArray.push(element.field)
                }
            })
            let params = {
                ...this.searchParams,
                ownerCode,
                owner: encodeURI(this.searchParams['owner']),
                moreThanTotalCount,
                columnStr: columnStrArray.join(','),
                codeList: this.selectCodes.join(',')
            }
            delete params.owner
            _doForm(InterObj.exportStorageGoodsListGroupByGoodsCode, '_self', 'post', params)
        },
        colChange(cols) {
            this.columnDefs = cols
        },
        btnchange(item) {
            item.click()
        }
    },

    activated() {
        let t = this
        t.$Loading.start()
        const key = this.$router.currentRoute.path + '-SHOWZERO'
        const showZero = store.get(key)
        if (!_.isUndefined(showZero)) {
            this.searchTaskForm.ifShowZeroData = showZero
        }
        let promiseArr = [this.getGoodsStateByOwner(), this.$refs.ownerSelect.ajaxPromise]
        t.gridOptions.onGridReady = () => {
            t.gridOptions.api.sizeColumnsToFit()
            const callBack = () => {
                t.gridOptions.api.sizeColumnsToFit()
            }
            t.$addResizeCallback(callBack)
        }
        // 查询表格
        let searchPromise = t.search()
        promiseArr.push(searchPromise)
        Promise.all(promiseArr).then(() => {
            t.$Loading.finish()
        }).catch(() => {
            t.$Loading.error()
        })
    }
}
</script>
<style scoped>
	.wms-table >>> .wms-row-warning {
		background-color: #ffe2d3 !important;
	}
</style>
